export default __webpack_public_path__ + "static/media/up-down.acb1bb1f.svg";